import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-css/components/dropdown.min.css';
import 'semantic-ui-css/components/flag.min.css';
import { apiGet, apiPatch } from 'services';
import { useDispatch, useSelector } from 'react-redux';
import { loadUserFromLocalStorage } from 'actions/user';
import { withRouter } from 'react-router-dom';

export const LanguageSelector = ({ history }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = React.useState(true);
    const [language, setLanguage] = React.useState('');
    const [languages, setLanguages] = React.useState([]);
    const { user } = useSelector(state => state.user);
    const loaded = React.useRef(null);

    React.useEffect(() => {
        const getFlag = x => (x?.length >= 2 ? x.slice(-2).toLowerCase() : '');
        apiGet('language', user.guid, response => {
            setLanguages(
                response.map(x => ({
                    key: x.code,
                    value: x.code,
                    flag: getFlag(x.code),
                    text: x.name,
                }))
            );
            setLoading(false);
        });
    }, []);

    React.useEffect(() => {
        setLanguage(user.language_Code);
    }, [user]);

    const changeLanguage = code => {
        setLanguage(code);
        apiPatch('language-set', { id: user.id, language_Code: code }, user.guid, response => {
            dispatch(loadUserFromLocalStorage(history, user.guid));
        });
    };

    return languages.length <= 1 ? null : (
        <div ref={loaded}>
            <Dropdown
                label="Select language"
                fluid
                loading={loading}
                labeled
                disabled={['PARTNER', 'SPOOF'].some(a => a === user.authority)}
                selection
                value={language}
                onChange={(e, data) => changeLanguage(data.value)}
                options={languages}
            />
        </div>
    );
};

export default withRouter(LanguageSelector);
